import React from 'react'
import { arrayOf, object, string, bool, number, func } from 'prop-types'
import intl from 'react-intl-universal'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'

import ThumbnailSlider from 'components/molecules/ThumbnailSlider'
import CampusPerfectCard from 'components/organisms/CampusPerfectCard'

const DetailRelatedCampus = ({ sectionTitle, schools, useAccentBg, paddingTop, paddingBottom, handleGTM }) => (
  <div id="related-campus" className="detail-related-campus">
    {useAccentBg && <div className="detail-related-campus__bg"/>}
    <SectionContainer
      className="detail-related-campus__content"
      backgroundColor="transparent"
      paddingBottom={paddingBottom}
      paddingTop={paddingTop}
    >
      <Container>
        <SectionTitle title={sectionTitle} align="left" />
      </Container>
      <ThumbnailSlider>
        {
          schools.map((school, idx) => (
            <div className="col-md-4 col-sm-6 col-xs-12" key={`sch-thm-${school.id}`}>
              <CampusPerfectCard
                dataTestId={`rec-campus-card-${idx}`}
                category={intl.get(`search.sector.${school.sector}`)}
                description={school.description}
                href={`/directory/${school.slug}`}
                kind="schools"
                likeable
                likeStatus={school.liked}
                likeTarget={school.id}
                logo={school.logo}
                title={school.name}
                thumbnail={school.image}
                withFooter
                onClick={() => handleGTM(school.name)}
              />
            </div>
          ))
        }
      </ThumbnailSlider>
    </SectionContainer>
    <style jsx>
      {`
        .detail-related-campus {
          position: relative;
          overflow: hidden;
          &__bg {
            background-color: #e3ecf5;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            transform: skewX(-80deg);
          }
          :global(&__content) {
            position: relative;
          }
        }
      `}
    </style>
  </div>
)

DetailRelatedCampus.propTypes = {
  schools: arrayOf(object),
  sectionTitle: string,
  useAccentBg: bool,
  paddingTop: number,
  paddingBottom: number,
  handleGTM: func,
}

DetailRelatedCampus.defaultProps = {
  sectionTitle: 'Kampus Terkait',
  useAccentBg: true,
  paddingTop: 80,
  paddingBottom: 80,
}

export default DetailRelatedCampus
